const changeOs = (os) => {
    const systemSwitcher = document.querySelector('#system-switcher');
    if (systemSwitcher) {
        JSON.parse(systemSwitcher.dataset.selector).forEach((selectorElement) => {
            const blockSelector = document.querySelector(selectorElement);
            systemSwitcher.classList.remove('win');
            systemSwitcher.classList.remove('mac');
            blockSelector.classList.remove('win');
            blockSelector.classList.remove('mac');
            systemSwitcher.classList.add(os);
            blockSelector.classList.add(os);
        });
    }
};
const detectOs = () => {
    if (navigator.userAgent.indexOf('Windows') !== -1) {
        changeOs('win');
        return 'win';
    }
    if (navigator.userAgent.indexOf('Mac') !== -1) {
        changeOs('mac');
        return 'mac';
    }
    changeOs('win');
    return 'win';
};
export { detectOs, changeOs };
